export default "__VITE_ASSET__25ced8b2__"